module.exports = __webpack_public_path__ + "static/media/Secure.dae9a4d7.svg";